import { HourReportFormTaskOption } from "../../api/schemas"

export const sortTaskOptionsByTreeOrder = (taskOptions: HourReportFormTaskOption[]): HourReportFormTaskOption[] => {
  return [...taskOptions].sort(compareFullTreeOrderPath)
}

export const filterOptionsByTitle = (
  options: HourReportFormTaskOption[],
  title: string
): HourReportFormTaskOption[] => {
  const filter = normalizeTitle(title)
  if (!filter) return options

  return options.filter((option) => {
    const selfMatch = normalizeTitle(option.title).includes(filter)
    const taskNumberMatch = normalizeTitle(option.taskNumber).includes(filter)
    const projectMatch = normalizeTitle(option.projectTitle).includes(filter)
    return selfMatch || taskNumberMatch || projectMatch
  })
}

export const groupByProjectNumberAndTitle = (option: HourReportFormTaskOption) => {
  return `${option.projectNumber} ${option.projectTitle}`
}

export const sortTaskOptionsByTreeAndProjectNumber = (
  taskOptions: HourReportFormTaskOption[]
): HourReportFormTaskOption[] => {
  return [...taskOptions].sort((a, b) => sortTaskOptionsByProjectNumber(a, b) || compareFullTreeOrderPath(a, b))
}

const sortTaskOptionsByProjectNumber = (a: HourReportFormTaskOption, b: HourReportFormTaskOption): number => {
  const aProjectNumber = a.projectNumber || ""
  const bProjectNumber = b.projectNumber || ""
  return aProjectNumber.localeCompare(bProjectNumber)
}

const compareFullTreeOrderPath = (a: HourReportFormTaskOption, b: HourReportFormTaskOption): number => {
  const sharedPathLength = Math.min(a.fullTreeOrderPath.length, b.fullTreeOrderPath.length)

  for (let index = 0; index < sharedPathLength; index += 1) {
    const orderDifference = a.fullTreeOrderPath[index] - b.fullTreeOrderPath[index]
    if (orderDifference !== 0) return orderDifference
  }

  return a.fullTreeOrderPath.length - b.fullTreeOrderPath.length
}

const normalizeTitle = (title: string): string => {
  return title.trim().toLowerCase()
}
